import { render, staticRenderFns } from "./DataOperations.vue?vue&type=template&id=8951daf8&"
import script from "./DataOperations.vue?vue&type=script&lang=js&"
export * from "./DataOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports